// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../../../../../../../../../node_modules/css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.id, ".xgplayer-skin-custom .xgplayer-time{display:inline-block;order:2;height:40px;margin:auto 8px;color:#fff;font-size:14px;font-family:PingFangSC-Regular,PingFang SC;line-height:32px;text-align:center}.xgplayer-skin-custom .xgplayer-time .xgplayer-time-current,.xgplayer-skin-custom .xgplayer-time span{color:#fff}.xgplayer-skin-custom .xgplayer-time .xgplayer-time-current:after{display:inline-block;padding:0 3px;content:\"/\"}", ""]);
// Exports
module.exports = exports;
